import React from 'react';
import { useAppSelector } from 'store/hooks';
import InvestLoadingView from '../components/InvestLoadingView';
import ConnectionFailedView from '../components/ConnectionFailedView';
import InvestOnboardingFunnel from '../components/InvestOnboardingFunnel';
import { selectShouldShowPortfolioBlock, selectShowMultiAccountTradingView } from '../reducers/selectors';
import MultiTradingAccountsView from '../components/MultiTradingAccountsView';
import ExtraInformationNeededBlock from '../components/InvestOnboardingFunnel/ExtraInformationNeededBlock';
// Takes no navigation props, so the web stack can use it as well as the native tab bar
const InvestScreen = () => {
    const accounts = useAppSelector((state) => state.invest.accounts);
    const shouldShowPortfolioBlock = useAppSelector(selectShouldShowPortfolioBlock);
    const showMultiAccountTradingView = useAppSelector(selectShowMultiAccountTradingView);
    const isErrorInFetchingInvestAcc = useAppSelector((state) => state.unpersistedInvestReducer.isErrorInFetchingInvestAcc);
    const hasntFetchedAccounts = accounts === undefined || !accounts.length;
    if (hasntFetchedAccounts) {
        if (isErrorInFetchingInvestAcc) {
            return <ConnectionFailedView />;
        }
        if (hasntFetchedAccounts) {
            return <InvestLoadingView />;
        }
    }
    if (showMultiAccountTradingView) {
        if (shouldShowPortfolioBlock) {
            return <ExtraInformationNeededBlock />;
        }
        return <MultiTradingAccountsView />;
    }
    return <InvestOnboardingFunnel />;
};
export default InvestScreen;
